import loadComponents from 'gia/loadComponents';
import Env from '../base/env.js';
import Channels from '../base/channels.js';
import lozad from 'lozad'
import Launcher from '../view/launcher'
import Smoothie from '../fx/Smoothie'
import MainnavTouch from '../ui/MainnavTouch'
import UISwitcher from '../ui/UISwitcher'

//! Components UI
import HoverMask from '../fx/HoverMask';

class UI
{
  constructor()
  {
    if(typeof history.scrollRestoration != 'undefined') {
        history.scrollRestoration = 'manual';
    }
    this.launcher = new Launcher()
    this.uiSwitch =  new UISwitcher()
    Env.framework.mainnav = new MainnavTouch()
    this.detectAppHeight()
    this.resetEnv();
    this.loader()
    // Smooth
    this.smoothie = new Smoothie()
    this.smoothie.setup()
    //!
    this.lazy()
    this.refreshMainnav()



  }

  appHeight()
  {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }

  detectAppHeight()
  {
    this.appHeight()
    Channels.on('window::smartresize',this.appHeight)
  }

  lazy()
  {
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
  }

  loader()
  {
    const components = {
      "HoverMask": HoverMask
    }

    loadComponents(components);
  }

  resetEnv()
  {
    Channels.on('statechange::before',function()
    {

    })
    Channels.on('statechange::ready',(current,old,container)=>
    {
      Env.$html.classList.remove('ui-white')
      Env.$html.classList.remove('cover-exit')
      Env.isVisiting = true
      if(Env.isVisiting === true) {
        if(typeof Env.framework.UI.smoothie != 'undefined') {
          Env.framework.UI.smoothie.setup()
        }
      }
      this.refreshMainnav()
    })
    Channels.on('statechange::finalize',()=>{
      this.lazy()
    })
  }

  refreshMainnav()
  {
    this.updateMainnavActive({url: window.location.href , namespace: Env.framework.toolbox.getController() })
  }

  updateMainnavActive(params,container)
  {
    const context = new URL(params.url)
    if(window.location.hash.length > 0) {
        context.url = window.location.href.split('#')[0]
    }
    if(window.location.search.length > 0) {
        context.url = window.location.href.split('?')[0]
    }
    for(let item of Env.$menuListeners) {
        const href = item.getAttribute('href').replace(/\/$/, "");
        const contextHref = context.href.replace(/\/$/, "");
        if(href == contextHref) {
            item.parentElement.classList.add('is-active')
        } else {
            item.parentElement.classList.remove('is-active')
        }
    }
  }
}

export default UI;
